// extracted by mini-css-extract-plugin
module.exports = {"container":"DaysField_container__37rl4","label":"DaysField_label__cEHDd","content":"DaysField_content__1CI6r","sending":"DaysField_sending__3_Mis"};